module.exports = __webpack_public_path__ + "img/customer_02.0516c75e.jpg";